<template>
  <Modal :id="id" title="Cancel Enrollment" :hide-close="true">
    <div slot="body" class="modal-body">
      <Alert :alert="alert" />
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-danger" href="#" @click.prevent="submit">Yes</a>
      <a class="btn btn-info" href="#" @click.prevent="close">No</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "course-enrollment-cancellation-modal",
      enrollment: null,
      alert: {
        type: "danger",
        message: "Are you sure you would like to CANCEL this enrollment?",
      },
    };
  },
  methods: {
    submit() {
      var url = this.route("admin.courses.enrollments.cancel", {
        enrollment: this.enrollment.id,
      });
      this.axios.delete(url).then(() => {
        this.resolve();
      });
    },
  },
  created() {
    this.enrollment = _.cloneDeep(this.options.enrollment);
  },
};
</script>